import type { User } from "@common/types/User";
import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { apiClient } from "apiClient";

export const queryKey = () => ["currentUser"];

const useCurrentUser = (
  options: Omit<UseQueryOptions<User>, "queryKey" | "queryFn"> = {}
) => {
  const { data: currentUser, ...rest } = useQuery({
    staleTime: Infinity,
    ...options,
    queryKey: queryKey(),
    queryFn: apiClient.user.fetchCurrentUser
  });

  return {
    currentUser,
    ...rest
  };
};

export const useSuspenseCurrentUser = () => {
  const { data: currentUser, ...rest } = useSuspenseQuery({
    staleTime: Infinity,
    queryKey: queryKey(),
    queryFn: apiClient.user.fetchCurrentUser
  });

  return { currentUser, ...rest };
};

export default useCurrentUser;
